<template>
  <Component
    v-bind="binding"
    :is="binding.is"
    ref="elRef"
    @click="handleLinkClick"
  >
    <slot />
  </Component>
</template>

<script lang="ts" setup>
import { computed, ref, toRefs } from "vue";
import type { LinkProps } from "./types";
import { useWebHaptics } from "../../composables/use-web-haptics";

const { triggerHaptic } = useWebHaptics();
const handleLinkClick = (): void => {
  triggerHaptic("rigid");
};

const props = withDefaults(defineProps<LinkProps>(), {
  fallbackComponent: "div",
});

const elRef = ref();
const { to, href, fallbackComponent } = toRefs(props);

const binding = computed(() => {
  if (to?.value) {
    return {
      is: "router-link",
      to: to.value,
    };
  }
  if (href?.value) {
    return {
      is: "a",
      target: "_blank",
      href: href.value,
      rel: "noopener noreferrer",
    };
  }

  return { is: fallbackComponent.value };
});

defineExpose({ elRef });
</script>
